import { Card } from "@mui/material";
import PropTypes from "prop-types";
import "./slide-up-card.scss";
import { FaAngleDown } from "react-icons/fa6";

const AwardCard = ({ imageUrl, title, content, customComponent }) => {
  const formatTitle = (title) => {
    const match = title.match(/^(.*?)(\d{4})(.*)/); // Capture everything before the year, the year, and the rest

    if (match) {
      return (
        <>
          <strong>
            {match[1]} {match[2]}
          </strong>
          {match[3]}
        </>
      );
    }

    return title; // Return the original title if no year is found
  };

  return (
    <Card
      className="slide-up-card shadow-lg"
      tabIndex="0"
      sx={{ height: "250px", width: "100%", maxWidth: "500px" }}
    >
      <div className="slide-up-card-info">
        <div className="d-flex gap-4 justify-content-center flex-column p-0 m-0">
          <div>
            <img src={imageUrl} width="70" alt="team data" />
          </div>
          <h4 className="m-0">{formatTitle(title)}</h4>
          <div>
            <FaAngleDown size={20} className="text-muted" />
          </div>
        </div>
      </div>

      <div className="slide-up-card-desc pb-0">
        <div className="d-flex align-items-center column-gap-2 pb-3">
          <img src={imageUrl} width="40" alt="team data" />
          <div className="d-flex flex-column p-0 m-0">
            <p className="m-0" style={{ fontSize: "1.1em" }}>
              {formatTitle(title)}
            </p>
            {customComponent}
          </div>
        </div>

        <div className="text-muted p-0">{content}</div>
      </div>
    </Card>
  );
};

AwardCard.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  customComponent: PropTypes.element // Optional custom component to render inside the card
};

export default AwardCard;
